import './style.css';
import api from 'util/api';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { omit } from 'lodash';
import { Banner } from '@thermon-platforms/thermon-ui-core';


function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // Grab redirect if applicable
  const params = new URLSearchParams(location.search);
  const returnTo = params.get('return_to');

  function handleSubmit(event) {
    event.preventDefault();

    // Clear previous errors
    delete errors.general;

    // Compile our credentials
    const formData = new FormData(event.target);
    const serializedData = {};
    for (const [key, value] of formData.entries()) {
      serializedData[key] = value;
    }

    if (!serializedData.username) {
      errors.username = `Must not be blank`;
    } else {
      delete errors.username;
    }

    if (!serializedData.password) {
      errors.password = `Must not be blank`;
    } else {
      delete errors.password;
    }

    if (Object.keys(errors).length) {
      setErrors(Object.assign({}, errors));
      return;
    }

    setLoading(true);

    // Request auth token
    api('/auth/Login', {
      method: 'POST',
      body: JSON.stringify(serializedData)
    })
      .then(() => {
        // If successful, return to the app
        navigate(returnTo || '/');
      })
      .catch(async res => {
        let msg;
        try {
          msg = res?.json ? await res.json() : undefined;
        } catch (e) {
          setLoading(false);
        }
        setErrors({general: msg || t`Login failed. Please try again.`});
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return(
    <div className="view login">
      <div className="login-wrapper">
        <h1>Thermon <span>Egis</span></h1>
        <div className="login-container">
          <section>
            <Banner status="alert" small={true} show={errors?.general}>{errors?.general}</Banner>
            <form id="account" method="post" onSubmit={handleSubmit}>
              <ul>
                <li>
                  <label htmlFor="username">
                    <Trans>Username</Trans>
                  </label>
                  <input
                    type="text"
                    id="username"
                    name="username"
                    className={errors?.username ? 'error' : ''}
                    onChange={() => setErrors(omit(errors, ['username', 'general']))}
                  />
                  {errors?.username ? <p className="error-text">{errors.username}</p> : <></>}
                </li>
                <li>
                  <label htmlFor="password">
                  <Trans>Password</Trans>
                  </label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    className={errors?.password ? 'error' : ''}
                    onChange={() => setErrors(omit(errors, ['password', 'general']))}
                  />
                  {errors?.password ? <p className="error-text">{errors.password}</p> : <></>}
                </li>
                {/* <li>
                  <div className="checkbox">
                    <label>
                      <input type="checkbox" />
                      <Trans>Remember Me</Trans>
                    </label>
                  </div>
                </li> */}
                <li>
                  <button
                    type="submit"
                    className={`primary ${loading ? 'processing' : ''}`}
                    disabled={loading}
                  >
                    <Trans>Log In</Trans>
                  </button>
                  {/* <a href="mailto:;?subject=Genesis Password Reset Request">
                    <Trans>Forgot Password?</Trans>
                  </a> */}
                </li>
              </ul>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Login;
